import { Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'

export interface SystemConfig {
	recaptcha: string
	locale: string
	event: {
		date: string
	}
	sentry: {
		dsn: string
		release: string
	}
	timezone: string
	currency: {
		code: string
		precision: number
		symbol: string
	}
	payment: {
		system: string
		initial_payment_amount: number
		account: {
			number: number
			sort_code: string
			name: string
		}
	}
}

@Injectable()
export class SystemConfigService extends BaseService<any> {
	public config: SystemConfig

	constructor() {
		super()
	}

	public getConfig = async () => {
		this.config = await this.get({ url: '/api/config' })
	}
}
